import { defineComponent as l, inject as c, createElementBlock as u, openBlock as _, mergeProps as w, unref as t, renderSlot as m, createCommentVNode as I, createVNode as n, withCtx as $ } from "vue";
import s from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/DataList/data-list.js";
import { useOUIAProps as g } from "../../helpers/ouia.js";
import k from "./DataListItemCells.vue2.js";
import v from "./DataListCell.vue2.js";
import y from "./DataListToggle.vue2.js";
import C from "../../helpers/AutoWrap.vue2.js";
import { DataListItemKey as L } from "./DataListItem.vue2.js";
const V = /* @__PURE__ */ l({
  name: "PfDataListItemRow",
  __name: "DataListItemRow",
  props: {
    wrapModifier: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(p, { expose: f }) {
    const a = p, d = g({ id: a.ouiaId, safe: a.ouiaSafe }), e = c(L);
    function r() {
      e && (e.expanded.value = !e.expanded.value);
    }
    return f({
      toggle: r
    }), (o, P) => {
      var i;
      return _(), u("div", w(t(d), {
        class: [
          t(s).dataListItemRow,
          {
            [t(s).modifiers[o.wrapModifier ?? "nowrap"]]: o.wrapModifier
          }
        ]
      }), [
        (i = t(e)) != null && i.expandable.value ? m(o.$slots, "toggle", { key: 0 }, () => [
          n(y, { onClick: r })
        ]) : I("", !0),
        n(C, {
          component: k,
          include: v
        }, {
          default: $(() => [
            m(o.$slots, "default")
          ]),
          _: 3
        })
      ], 16);
    };
  }
});
export {
  V as default
};
